module.exports = __webpack_public_path__ + "img/poison.347a143d.png";